module.exports = __webpack_public_path__ + "static/media/addresses.ec47a3fa.svg";